import React from 'react';
import { Dialog, DialogActions } from '@mui/material';
import EnhancedTab from '../../../../../../../../lib/designSystem/TabSimulation';
import RiskReviews from '../../../../../Financing/common/riskReviews';
import { cellFormat } from '../../../../../../../../lib/designSystem/Table/cellFormat';
import CustomButton from '../../../../../../../../lib/designSystem/Button';
import VerificationModule from '../../../../../Collection/components/Verification';

export const PAYOUT_AVAILABLE_STAGES = [
  'Aceptada',
  'Cedida',
  'Activa',
  'Completada',
  'En mora',
];
export const EXECUTED_STAGES = [
  'Activa',
  'Completada',
  'En mora',
  'Completada',
];

const ShoppingDialogRecieved = (props: any) => {
  const { openShoppingCart, setOpenShoppingCart, selectedRequest, setUp } =
    props;
  const startValue = 0;
  const goToRiskTimes = 1;

  console.log(selectedRequest);

  const ImportedModuleLayout = (props: any) => {
    return (
      <div>
        {props.children}
        <DialogActions>
          <CustomButton
            onClick={() => setOpenShoppingCart(false)}
            color="secondary"
            style={{ marginTop: '10px' }}
          >
            Salir
          </CustomButton>
        </DialogActions>
      </div>
    );
  };

  const tabs = [
    {
      index: 0,
      label: 'Verificación',
      component: (
        <VerificationModule
          preSettedFactoringRequestId={selectedRequest?.id}
          preSettedConfirmationType="all"
          setOpenShoppingCart={setOpenShoppingCart}
          setUp={setUp}
        />
      ),
      path: 'recieved',
    },
    {
      index: 1,
      label: 'Riesgo',
      component: (
        <ImportedModuleLayout>
          <RiskReviews
            selectedRequest={selectedRequest}
            requestType="factoring-request"
          />
        </ImportedModuleLayout>
      ),
      path: 'recieved',
    },
  ];

  return (
    <>
      <Dialog maxWidth="xl" fullWidth open={openShoppingCart}>
        <div style={{ padding: 20, minHeight: 200 }}>
          <EnhancedTab
            title={`Solicitud #${cellFormat(selectedRequest?.id, 'numeric-id')}`}
            startValue={startValue}
            tabs={tabs}
            updater={goToRiskTimes}
            chip={cellFormat(selectedRequest?.status, 'status')}
          />
        </div>
      </Dialog>
    </>
  );
};

export default ShoppingDialogRecieved;
